import { ThemeProvider, createTheme } from "@mui/material";
// assets - UNUSED FOR NOW
// import AvenirNextRegular from "assets/fonts/AvenirNext-Regular.ttf";
// import AvenirNextMedium from "assets/fonts/AvenirNext-Medium.ttf";
// import AvenirNextBoldItalic from "assets/fonts/AvenirNext-BoldItalic.ttf";
// import AvenirNextDemiBold from "assets/fonts/AvenirNext-DemiBold.ttf";
// import MontserratRegular from "assets/fonts/Montserrat-Regular.ttf";
// import MontserratMedium from "assets/fonts/Montserrat-Medium.ttf";

/**
 * * Wrapper for the MUI ThemeProvider
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @returns {Object} CustomThemeProvider
 */
export default function CustomThemeProvider({ children }) {
  // PALETTE COLORS
  let palette = {
    primary: {
      main: "#72aa64",
    },
    secondary: {
      main: "#1b4b60",
    },
    info: {
      main: "#7a1ad9",
    },
    background: {
      default: "#000",
      paper: "#111",
    },
  };

  // BASE TYPOGRAPHY
  let typography = {
    fontFamily: [
      // "AvenirNext",
      // "Montserrat",
      "Helvetica Neue",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "Oxygen",
      "Ubuntu",
      "Cantarell",
      "Fira Sans",
      "Droid Sans",
      "sans-serif",
    ].join(","),
    allVariants: {
      color: "#fff",
    },
  };

  // BASE FONT LOADING
  let components = {
    // MuiCssBaseline: {
    //   styleOverrides: {
    //     "@font-face": [
    //       {
    //         fontFamily: "AvenirNext",
    //         fontWeight: 400,
    //         fontStyle: "normal",
    //         fontDisplay: "swap",
    //         src: `url(${AvenirNextRegular}) format('truetype')`,
    //       },
    //       {
    //         fontFamily: "AvenirNext",
    //         fontWeight: 500,
    //         fontStyle: "normal",
    //         fontDisplay: "swap",
    //         src: `url(${AvenirNextMedium}) format("truetype")`,
    //       },
    //       {
    //         fontFamily: "AvenirNext",
    //         fontWeight: "bold",
    //         fontStyle: "italic",
    //         fontDisplay: "swap",
    //         src: `url(${AvenirNextBoldItalic}) format("truetype")`,
    //       },
    //       {
    //         fontFamily: "AvenirNext",
    //         fontWeight: 600,
    //         fontStyle: "normal",
    //         fontDisplay: "swap",
    //         src: `url(${AvenirNextDemiBold}) format("truetype")`,
    //       },
    //     {
    //       fontFamily: "Montserrat",
    //       fontWeight: 400,
    //       fontStyle: "normal",
    //       fontDisplay: "swap",
    //       src: `url(${MontserratRegular}) format("truetype")`,
    //     },
    //     {
    //       fontFamily: "Montserrat",
    //       fontWeight: 500,
    //       fontStyle: "normal",
    //       fontDisplay: "swap",
    //       src: `url(${MontserratMedium}) format("truetype")`,
    //     },
    //     ],
    //   },
    // },
  };

  let theme = createTheme({
    palette: { ...palette },
    typography: { ...typography },
    components: { ...components },
  });

  theme = customResponsiveFontSizes(theme);
  // theme = responsiveFontSizes(theme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

/**
 * * Function that adds custom responsive font sizes to a theme
 * BUG: Astrin-Biosciences/web-astrinbio#2
 * TODO: Make mobile font sizes as default
 * @param {Object} theme
 * @returns {Object} theme
 */
function customResponsiveFontSizes(theme) {
  // H1 - MAIN HEADER
  theme.typography.h1 = {
    ...theme.typography.h1,
    // sizing
    fontSize: "5.5rem",
    [theme.breakpoints.down("xl")]: {
      fontSize: "5rem",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "4.5rem",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "3.4rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.7rem",
    },
  };

  // H2 - SECTION HEADER
  theme.typography.h2 = {
    ...theme.typography.h2,
    // main
    color: theme.palette.primary.main,
    fontWeight: "bold",
    // sizing
    fontSize: "5.5rem",
    [theme.breakpoints.down("xl")]: {
      fontSize: "4.5rem",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "4.2rem",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "3.4rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.9rem",
    },
  };

  // H3 - SUBSECTION HEADER
  theme.typography.h3 = {
    ...theme.typography.h3,
    color: theme.palette.primary.main,
    fontWeight: "bold",
    // sizing
    fontSize: "5rem",
    [theme.breakpoints.down("xl")]: {
      fontSize: "3.5rem",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "3.4rem",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "3rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.6rem",
    },
  };

  // H4 - SECTION SUBHEADER -- UNUSED
  theme.typography.h4 = { ...theme.typography.h4 };

  // H5 - MAIN SUBHEADER
  theme.typography.h5 = {
    ...theme.typography.h5,
    // main
    color: theme.palette.primary.main,
    // sizing
    fontSize: "3rem",
    [theme.breakpoints.down("xl")]: {
      fontSize: "2.5rem",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "2rem",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.8rem",
    },
    [theme.breakpoints.down("sm")]: {},
  };

  // H6 - BODY TEXT LARGE
  theme.typography.h6 = {
    ...theme.typography.h6,
    // sizing
    fontSize: "2.5rem",
    [theme.breakpoints.down("xl")]: {
      fontSize: "2.3rem",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "1.9rem",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.8rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.6rem",
    },
  };

  // subtitle1 - SUBSECTION SUBHEADER
  theme.typography.subtitle1 = {
    ...theme.typography.subtitle1,
    // main
    fontWeight: "bold",
    fontStyle: "italic",
    // sizing
    fontSize: "1.8rem",
    [theme.breakpoints.down("xl")]: {
      fontSize: "1.6rem",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.4rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.3rem",
    },
  };

  // subtitle2 - NO ROLE -- UNUSED
  theme.typography.subtitle2 = { ...theme.typography.subtitle2 };

  // body1 - BODY TEXT NORMAL
  theme.typography.body1 = {
    ...theme.typography.body1,
    // main
    lineHeight: "2.3rem",
    // sizing
    fontSize: "1.2rem",
    [theme.breakpoints.down("xl")]: {},
    [theme.breakpoints.down("lg")]: {},
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {},
  };

  // body2 - BODY TEXT SMALL
  theme.typography.body2 = {
    ...theme.typography.body2,
    // sizing
    fontSize: "1rem",
    [theme.breakpoints.down("xl")]: {
      fontSize: "0.9rem",
    },
    [theme.breakpoints.down("lg")]: {
      // fontSize: "0.85rem",
    },
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {},
  };

  // button - BUTTON TEXT
  theme.typography.button = {
    ...theme.typography.button,
    // sizing
    fontSize: "1rem",
    [theme.breakpoints.down("xl")]: {
      fontSize: "0.9rem",
    },
    [theme.breakpoints.down("lg")]: {},
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {},
  };

  // caption - CAPTION TEXT
  theme.typography.caption = {
    ...theme.typography.caption,
    // sizing
    fontSize: "0.9rem",
    [theme.breakpoints.down("xl")]: {},
    [theme.breakpoints.down("lg")]: {},
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {},
  };

  // overline - FOOTNOTE / OVERLINE TEXT
  theme.typography.overline = {
    ...theme.typography.overline,
    // sizing
    fontSize: "0.9rem",
    [theme.breakpoints.down("xl")]: {},
    [theme.breakpoints.down("lg")]: {},
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {},
  };

  return theme;
}
